<template>
  <div v-show="editShow">
    <div class="container">
      <el-row :gutter="20">
        <div class="clearfix">
          <div class="crumbs">
            <i class="el-icon-back"></i>
            <el-button type="text" @click="goBack">返回</el-button>
          </div>
          <div class="btn-save">
            <el-button type="primary" @click="saveClick('ruleForm')"
            >保存
            </el-button
            >
          </div>
        </div>
        <div class="form-box">
          <el-form
              :model="ruleForm"
              :rules="rules"
              ref="ruleForm"
              label-width="120px"
              class="eidt-el-form el-form-wrap"
          >
            <div class="line-box">
              <el-form-item label="启用状态:">
                <el-radio-group
                    v-model="ruleForm.disabled"
                >
                  <el-radio :label="0">启用</el-radio>
                  <el-radio :label="1">禁用</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="查看权限:">
                <el-radio-group
                    v-model="ruleForm.look"
                >
                  <el-radio :label="0">登录</el-radio>
                  <el-radio :label="1">分论坛权限</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="投票权限:">
                <el-radio-group
                    v-model="ruleForm.isVerify"
                >
                  <el-radio :label="0">登录</el-radio>
                  <el-radio :label="1">分论坛权限</el-radio>
                </el-radio-group>
              </el-form-item>
            </div>
            <div class="line-box">
              <el-form-item label="标题名称:" prop="name">
                <el-input v-model="ruleForm.name"></el-input>
              </el-form-item>
              <el-form-item label="分论坛:" prop="market">
                <el-input v-model="ruleForm.market"></el-input>
              </el-form-item>
              <el-form-item label="投票规则:" prop="type">
                <el-select
                    placeholder="投票规则:"
                    clearable
                    v-model="ruleForm.type"
                    class="el-input-position"
                >
                  <el-option
                      label="不允许重复投票"
                      :value="0"
                  ></el-option>
                  <el-option
                      label="允许重复投票"
                      :value="1"
                  ></el-option>
                </el-select>
              </el-form-item>
            </div>
            <div class="line-box">
              <el-form-item label="每人X天:" prop="day">
                <el-input-number :max="999999" :min="0" v-model="ruleForm.day"></el-input-number>
              </el-form-item>
              <el-form-item label="可投X票:" prop="ticket">
                <el-input-number :max="999999" :min="0" v-model="ruleForm.ticket"></el-input-number>
              </el-form-item>
              <el-form-item label="总投票数:" prop="total">
                <el-input-number disabled="disabled" :max="99999999999" :min="0"
                                 v-model="ruleForm.total"></el-input-number>
              </el-form-item>
            </div>
            <div class="line-box">
              <el-form-item label="开始时间" prop="startDate">
                <el-date-picker
                    value-format="yyyy-MM-dd HH:mm:ss"
                    v-model="ruleForm.startDate"
                    type="datetime"
                    placeholder="开始日期"
                ></el-date-picker>
              </el-form-item>
              <el-form-item prop="banner" :label="imgTitle">
                <el-input v-model="ruleForm.banner"></el-input>
              </el-form-item>
              <el-form-item prop="banner1" :label="imgTitle1">
                <el-input v-model="ruleForm.banner1"></el-input>
              </el-form-item>
            </div>
            <div class="line-box">
              <el-form-item
                  label="结束时间:"
                  prop="endDate"
              >
                <el-date-picker
                    value-format="yyyy-MM-dd HH:mm:ss"
                    v-model="ruleForm.endDate"
                    type="datetime"
                    placeholder="结束日期"
                ></el-date-picker>
              </el-form-item>
              <el-form-item prop="banner" :label="imgTitle">
                <UploadImg
                    @uploadImg="getUploadImg"
                    :editImg="editImg"
                ></UploadImg>
              </el-form-item>
              <el-form-item prop="banner1" :label="imgTitle1">
                <UploadImg
                    @uploadImg="getUploadImg1"
                    :editImg="editImg1"
                ></UploadImg>
              </el-form-item>
            </div>
            <div class="line-box">
              <el-form-item label="投票次数提示" prop="tip">
                <el-input v-model="ruleForm.tip"></el-input>
              </el-form-item>
              <el-form-item label="未开始提示" prop="tip1">
                <el-input v-model="ruleForm.tip1"></el-input>
              </el-form-item>
              <el-form-item label="已结束提示" prop="tip2">
                <el-input v-model="ruleForm.tip2"></el-input>
              </el-form-item>
            </div>
          </el-form>
        </div>
      </el-row>
    </div>
  </div>
</template>
<script>
var types = [
  {name: "不允许重复投票", value: 0},
  {name: "允许重复投票", value: 1},
];

import UploadImg from "../public/UploadImg";

export default {
  name: "editvihicel",
  data() {
    return {
      labels: [],
      optionsCopy: [],
      rules: {
        ticket: [{required: true, message: "票数不能为空", trigger: "blur"},],
        startDate: [{required: true, message: "开始日期不能为空", trigger: "blur"}],
        endDate: [{required: true, message: "结束日期不能为空", trigger: "blur"}],
        day: [{required: true, message: "天数不能为空", trigger: "blur"}],
        name: [{required: true, message: "名称不能为空", trigger: "blur"}],
        banner: [{required: true, message: "头部图片不能为空", trigger: "blur"}],
        total: [{required: false, message: "总脱皮不能为空", trigger: "blur"}],
        disabled: [{required: true, message: "状态不能为空", trigger: "blur"}],
        market: [{
          required: true,
          message: "分论坛不能为空",
          trigger: "blur"
        }],

      },
      projectId: localStorage.getItem("project_Id"),
      DocumentType: [],
      ruleForm: {
        market: '无',
        look: 0,
        disabled: 0,
        isVerify: 0,
        showTicket: 0,
        ticket: 1,
        total: 0,
        day: 1,
        name: "",
        banner: "",
        banner1: "",
        tip: "",
        tip1: "",
        tip2: "",
        type: 0,
        startDate: "",
        endDate: "",
        projectId: localStorage.getItem("project_Id"),
      },
      voteId: "",
      editImg: "",
      editImg1: "",
      imgTitle: "头部图片:",
      imgTitle1: "底部图片:",
    };
  },
  created() {
  },
  props: {
    editShow: {
      type: Boolean,
      default: false,
    },
    editData: {
      type: Object,
    },
  },
  watch: {
    editData: function () {
      if (this.editData) {
        this.ruleForm = this.editData;
        this.voteId = this.editData.voteId;
        this.editImg = this.editData.banner;
        this.editImg1 = this.editData.banner1;
      }
    },
  },
  methods: {
    saveClick(ruleForm) {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          if (this.voteId == "" || this.voteId == undefined) {
            this.$axios.post("/Vote/", this.ruleForm).then((res) => {
              if (res.data.hasError == false) {
                this.$message.success("保存成功！");
              } else {
                this.$message.error(res.data.message);
              }
            });
          } else {
            this.$axios
                .put("/Vote/" + this.voteId + "", this.ruleForm)
                .then((res) => {
                  if (res.data.hasError == false) {
                    this.$message.success("编辑成功！");
                    this.goBack();
                  } else {

                    this.$message.error(res.data.message);
                  }
                });
          }
        } else {
          return false;
        }
      });
    }
    ,
    goBack() {
      this.editData = null;
      this.voteId = "";
      this.$emit("backFunStu");
      this.$refs.ruleForm.resetFields();
      this.editImg = "";
      this.editImg1 = "";
      this.list.tableData = [];
    }
    ,
    getUploadImg(imgSrc) {
      this.ruleForm.banner = imgSrc;
    }
    ,
    getUploadImg1(imgSrc) {
      this.ruleForm.banner1 = imgSrc;
    }
    ,
  },
  components: {
    UploadImg,
  }
  ,
}
;
</script>

<style lang="scss" scoped>
.el-form-wrap {
  width: 100% !important;
}

.line-box {
  display: flex;
  flex: 1;
}

.line-box .el-form-item,
.line-box .up-img {
  width: 40% !important;
}

.my-autocomplete {
  li {
    line-height: normal;
    padding: 7px;

    .name {
      text-overflow: ellipsis;
      overflow: hidden;
    }

    .addr {
      font-size: 12px;
      color: #b4b4b4;
    }

    .highlighted .addr {
      color: #ddd;
    }
  }
}
</style>